import { logDev } from "@frontend/utils/logging";
import { noop } from "@frontend/utils/utils";
import * as Sentry from "@sentry/react";

export const SentryUtil = {
  init: () => {
    if (import.meta.env.MODE !== "production") {
      logDev("Skip initializing sentry.io in non-production environment");
      return;
    }

    globalThis.console.log = noop;
    globalThis.console.dir = noop;
    globalThis.console.table = noop;
    globalThis.console.warn = noop;
    globalThis.console.error = (error: string | Error, ...optionalParams: any[]) => {
      Sentry.captureException(error, {
        level: "error",
        extra: { "bella-rates": optionalParams },
      });
    };

    const sentryDSN = document.querySelector("meta[name=SENTRY_DSN]")?.getAttribute("content");

    if (sentryDSN) {
      logDev("Initializing sentry.io error tracing");
      try {
        Sentry.init({
          dsn: sentryDSN,
          integrations: [],
          ignoreErrors: [
            "Non-Error promise rejection",
            "Network Error",
            "ResizeObserver loop limit exceeded",
            "_avast_submit",
          ],
          tracesSampleRate: 0.1,
        });
      } catch (error) {
        logDev("Failed to initialize sentry.io");
        console.warn(error);
      }
    } else {
      logDev("Skip initializing sentry.io");
    }
  },
};
